import { ISelectInput, List, Typography } from "payzli-ui";
import { useEffect, useState } from "react";
import { enumRoutes, sidebarItems } from "../../utils/helper";
import styles from "./Sidebar.module.css";
import { useNavigate } from "react-router";

const Sidebar = () => {
	const navigate = useNavigate();
	const [selectedItem, setSelectedItem] = useState<any>(null);
	useEffect(() => {
		const path = window.location.pathname.split("/")[1];
		const item = sidebarItems.find((item) => item.value === path);
		if (item) {
			setSelectedItem(item);
		} else {
			setSelectedItem(sidebarItems.find((item) => item.value === "buttons"));
			navigate(enumRoutes.buttons);
		}
	}, []);
	const handleSelect = (item: ISelectInput) => {
		setSelectedItem(item);
		navigate(`/${item?.value}`);
	};
	return (
		<div className={styles.sidebar_container}>
			<div className={styles.sidebar_header}>
				<Typography size="xl" fontFamily="semibold" type="text">
					Components
				</Typography>
			</div>
			<List
				list_container_class="w-100"
				list_item_class="w-100"
				options={sidebarItems}
				selectedItem={selectedItem}
				setSelectedItem={(value: any) => handleSelect(value)}
			></List>
		</div>
	);
};

export default Sidebar;
